import { Component, OnInit, ChangeDetectionStrategy, Inject, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';

@Component({
  selector: '',
  template: '',
  standalone: true,
})
export class FormsContainerComponent<T> implements AfterViewInit {
  navBtnClick$!: Observable<number> //= this._store.select(selectNavBtnClick);
  disableNav: boolean = true;
  selectNavBtnClick!: (state: T) => number;
  constructor(
    readonly _store: Store<T>,
    // readonly selectNavBtnClick: (state: T) => number
  ) {
  }

  ngAfterViewInit(): void {
    if (this.selectNavBtnClick) {
      this.navBtnClick$ = this._store.select(this.selectNavBtnClick);
    }
  }

  disableNavBtn(disable: boolean) {
    this.disableNav = disable;
  }
}
